import type { Presence } from '@play-co/replicant';

/**
 * Visit availability, decided from the Replicant Presence API.
 *
 * Presence is derived from the player's last action timestamp, so it reports a player as away
 * as soon as they stop playing, with no state flag to keep in sync.
 *
 * All visit surfaces go through this module so the rule lives in one place.
 */

/**
 * `searchPlayers` `where` fragment that keeps only players available to visit.
 *
 * @example
 * api.searchPlayers({ where: { ...availableToVisitWhere(), petSpecies: ... } });
 */
export function availableToVisitWhere() {
  return { presence: { isOneOf: ['offline'] as Presence[] } };
}

/**
 * Whether the evaluated player counts as online, meaning busy and not available to visit.
 *
 * A player whose presence is unknown counts as online: a visit is offered only on positive
 * evidence that the other player is away.
 *
 * @param presence The evaluated player's presence.
 */
export function isOnlineForVisit(presence?: Presence): boolean {
  return presence !== 'offline';
}
